module.exports = __webpack_public_path__ + "img/mastercard.dc9db176.svg";